import { createFileRoute } from '@tanstack/react-router'
import { SerialEditor } from './-SerialEditor'

export const Route = createFileRoute('/inventory/serials/$id')({
  component: SerialDetailPage,
})

function SerialDetailPage() {
  const { id } = Route.useParams()
  return <SerialEditor id={id} />
}
